import { BrowserModule } from '@angular/platform-browser';
import { NgModule , NO_ERRORS_SCHEMA, ErrorHandler} from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CoreModule } from '@app/core';
import { LoginModule } from '@app/login/login.module';
import { HomeModule } from '@app/home/home.module';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { IdentityModule } from '@app/identity/identity.module';
import { RegisterModule } from '@app/register/register.module';
import { NgbModule, NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { GlobalErrorHandlerService } from '@app/core/services/global-error-handler.service';
import { PopupComponent } from '@app/popup/popup.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { PasswordModule } from '@app/password/password.module';
import { CompareDirective } from './shared/directives/compare.directive';
import { PhoneMaskDirective } from './shared/directives/phone-mask.directive';
import {NgxMaskModule} from 'ngx-mask';
import { RegistersuccessfulModule } from '@app/registersuccessful/registersuccessful.module';
import { FormsModule, ReactiveFormsModule } from '../../node_modules/@angular/forms';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgHttpLoaderModule } from 'ng-http-loader'; 
import { DeviceDetectorService } from '../../node_modules/ngx-device-detector';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from '@app/core/services/ngb-date-fr-parser-formatter';
import { CustomDateFormatterDirective } from '@app/shared/directives/date-formatter.directive';
import { GoogleChartsModule, GoogleChartComponent } from 'angular-google-charts';

@NgModule({
  declarations: [
    AppComponent,
    PopupComponent,
    
    CompareDirective,
    PhoneMaskDirective,
    CustomDateFormatterDirective
  ],
  imports: [
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    BrowserModule,
    MDBBootstrapModule.forRoot(),
    NgbModule.forRoot(),
    NgxMaskModule.forRoot(),
    HttpClientModule,
    CoreModule,
    HomeModule,
    LoginModule,
    IdentityModule,
    RegisterModule,
    RegistersuccessfulModule,
    PasswordModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgHttpLoaderModule,
    NgbTabsetModule,
    GoogleChartsModule.forRoot()
    ],
  schemas: [ NO_ERRORS_SCHEMA ],
  providers: [
    GlobalErrorHandlerService,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    DeviceDetectorService,
    {provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter}
  ],
  entryComponents: [PopupComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }